import React from 'react';
import classnames from 'classnames';
import {ErrorMessage} from 'formik';
import _get from 'lodash/get';

export default function InputBox({
  style,
  postfix,
  field,
  form: {touched, errors},
  showError = false,
  ...props
}) {
  return (
    <>
      <div className="d-flex">
        <input
          {...props}
          {...field}
          value={_get(field, 'value', '')}
          className={classnames({
            'form-control': true,
            'is-invalid': _get(touched, field.name) && _get(errors, field.name),
          })}
          style={style && style}
        />
        {postfix && (
          <span className="kt-margin-t-10 kt-margin-l-5">{postfix}</span>
        )}
      </div>
      <span
        className={classnames({
          'invalid-feedback': !showError,
        })}
        style={{color: '#fd397a'}}
      >
        <ErrorMessage name={field.name} />
      </span>
    </>
  );
}
